export const partnerInfos = {
  name: 'Ogury',
  version: '1.0.0'
};
